import { html, nothing } from 'lit';
import componentStyles from './access-medical-records.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class AccessMedicalRecords extends OutlineElement {
  static styles = [super.styles, componentStyles];

  constructor() {
    super();

    if (typeof window._sbr === 'undefined') {
      this.attachWidget()
    }

    window.addEventListener('load', (event) => {
      window._sbr.init()
    });
  }

  createRenderRoot() {
    return this;
  }

  receiveMessage(event) {
    if (event.data === 'hide') {
      let ask = confirm("You're about to close this request which will reset all fields.  Do you want to continue?");

      if (ask) {
        window._sbr.surveyTeardown();
      } else {
        return true;
      }

    } else if (event.data === 'close') {
      window._sbr.surveyTeardown();
    } else {
      return eval(event.data);
    }
  }

  attachWidget() {
    let medicalRecordsScript = document.createElement('script');
    medicalRecordsScript.type = 'text/javascript';
    medicalRecordsScript.src = 'https://healthcare.healthrecordwizard.com/plugins/wizard/js/sbr.js';
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(medicalRecordsScript);

    window.addEventListener("message", this.receiveMessage, false);
  }

  render() {
    return html`
      <div class="access-medical-records">
        <div id="swellbox_request_container"
             style="display: none; width: 100%; height: 100%; position: fixed; top: 0px; left: 0px; z-index: 100000000; background-color: transparent;">
          <iframe id="swellbox_request_frame" name="swellbox_request_frame" title="Request Wizard Frame"
                  src="https://www.swellbox.com/healthfirst-wizard.html"
                  allowtransparency="true" contentaccessible="true" marginwidth="0" tabindex="0" scrolling="no" allow="camera"
                  style="width: 100%; height: 100%; background-color: transparent; border: 0px;"
                  aria-label="Request Wizard Frame" loaded="1"></iframe>
        </div>

        <a class="main__button main__button-md request-form btn link-btn--primary" href="javascript:;" data-school="false"
           data-provider="Health First" data-provider-tag="healthfirst"
           data-provider-tagline="Request health records from<br class='hideable-break'/> Health First."
           data-logo="https://healthcare.healthrecordwizard.com/plugins/wizard/gfx/healthfirst/logo.png"
           data-bg="https://healthcare.healthrecordwizard.com/plugins/wizard/gfx/healthfirst/bg.jpg" data-auto-open="false"
           data-fullscreen="false" rel="noopener">Click Here to Request Medical Records</a>
      </div>
    `;
  }
}
customElements.define('hf-access-medical-records', AccessMedicalRecords);
